var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3125 14.125H10.1875V31.1875H2.3125C1.9644 31.1875 1.63056 31.0492 1.38442 30.8031C1.13828 30.5569 1 30.2231 1 29.875V15.4375C1 15.0894 1.13828 14.7556 1.38442 14.5094C1.63056 14.2633 1.9644 14.125 2.3125 14.125V14.125Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 14.125L16.75 1C17.4394 1 18.1221 1.1358 18.7591 1.39963C19.396 1.66347 19.9748 2.05018 20.4623 2.53769C20.9498 3.0252 21.3365 3.60395 21.6004 4.24091C21.8642 4.87787 22 5.56056 22 6.25V10.1875H32.1514C32.5237 10.1875 32.8916 10.2667 33.2309 10.4197C33.5702 10.5728 33.873 10.7962 34.1194 11.0753C34.3657 11.3543 34.5499 11.6825 34.6596 12.0382C34.7694 12.3938 34.8023 12.7688 34.7562 13.1381L32.7874 28.8881C32.7081 29.523 32.3996 30.107 31.9199 30.5304C31.4403 30.9538 30.8225 31.1875 30.1827 31.1875H10.1875",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.3d90541965ce4e2d1277cd9ea64e0387.svg";
export { ForwardRef as ReactComponent };